import type { Can, Category } from './api.js';

/** Lowercase without accents: "Rosá" → "rosa", "M³" → "m3". */
export const fold = (s: string) =>
  s
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase();

const words = (s: string) => fold(s).split(/[^a-z0-9]+/).filter(Boolean);

/**
 * Flavors whose name (or category) contains every typed word. Names that
 * start with the query come first, then names where every word starts one of
 * theirs, then the rest.
 */
export function searchCans(cans: Can[], categories: Category[], query: string, limit = Infinity): Can[] {
  const terms = words(query);
  if (!terms.length) return [];
  const full = terms.join(' ');
  const catWords = new Map(categories.map((c) => [c.id, words(c.name)]));

  const scored: Array<[number, Can]> = [];
  for (const can of cans) {
    const nameWords = words(can.name);
    const all = [...nameWords, ...(catWords.get(can.categoryId) ?? [])];
    const hay = all.join(' ');
    const hit = terms.every((t) => all.some((w) => w.startsWith(t)) || (t.length >= 3 && hay.includes(t)));
    if (!hit) continue;
    const score = nameWords.join(' ').startsWith(full)
      ? 0
      : terms.every((t) => nameWords.some((w) => w.startsWith(t)))
        ? 1
        : 2;
    scored.push([score, can]);
  }
  return scored
    .sort(([a, x], [b, y]) => a - b || x.name.length - y.name.length || x.name.localeCompare(y.name, 'nl'))
    .slice(0, limit)
    .map(([, can]) => can);
}
